import React, { Component } from 'react';

class Footer extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        let props = this.props;

        return (
            <div className="row top-separator-xs">
                
            </div>
        );
    }

};
export default Footer;